// source: pbtypes/gen/calibration/camera_intrinsics.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_calibration_distortion_model_pb = require('../../../pbtypes/gen/calibration/distortion_model_pb.js');
goog.object.extend(proto, pbtypes_gen_calibration_distortion_model_pb);
var pbtypes_gen_eigen_lcm_Vector2d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector2d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector2d_pb);
goog.exportSymbol('proto.calibration.CameraIntrinsics', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.calibration.CameraIntrinsics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.calibration.CameraIntrinsics.repeatedFields_, null);
};
goog.inherits(proto.calibration.CameraIntrinsics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.calibration.CameraIntrinsics.displayName = 'proto.calibration.CameraIntrinsics';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.calibration.CameraIntrinsics.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.calibration.CameraIntrinsics.prototype.toObject = function(opt_includeInstance) {
  return proto.calibration.CameraIntrinsics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.calibration.CameraIntrinsics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.CameraIntrinsics.toObject = function(includeInstance, msg) {
  var f, obj = {
distortionCoefficientsList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f,
distortionModel: jspb.Message.getFieldWithDefault(msg, 2, 0),
focalLength: (f = msg.getFocalLength()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f),
principalPoint: (f = msg.getPrincipalPoint()) && pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.calibration.CameraIntrinsics}
 */
proto.calibration.CameraIntrinsics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.calibration.CameraIntrinsics;
  return proto.calibration.CameraIntrinsics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.calibration.CameraIntrinsics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.calibration.CameraIntrinsics}
 */
proto.calibration.CameraIntrinsics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      reader.readPackableDoubleInto(msg.getDistortionCoefficientsList());
      break;
    case 2:
      var value = /** @type {!proto.calibration.DistortionModel.Enum} */ (reader.readEnum());
      msg.setDistortionModel(value);
      break;
    case 3:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setFocalLength(value);
      break;
    case 4:
      var value = new pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.deserializeBinaryFromReader);
      msg.setPrincipalPoint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.calibration.CameraIntrinsics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.calibration.CameraIntrinsics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.calibration.CameraIntrinsics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.calibration.CameraIntrinsics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDistortionCoefficientsList();
  if (f.length > 0) {
    writer.writePackedDouble(
      1,
      f
    );
  }
  f = message.getDistortionModel();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getFocalLength();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
  f = message.getPrincipalPoint();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb.serializeBinaryToWriter
    );
  }
};


/**
 * repeated double distortion_coefficients = 1;
 * @return {!Array<number>}
 */
proto.calibration.CameraIntrinsics.prototype.getDistortionCoefficientsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.calibration.CameraIntrinsics} returns this
 */
proto.calibration.CameraIntrinsics.prototype.setDistortionCoefficientsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.calibration.CameraIntrinsics} returns this
 */
proto.calibration.CameraIntrinsics.prototype.addDistortionCoefficients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.calibration.CameraIntrinsics} returns this
 */
proto.calibration.CameraIntrinsics.prototype.clearDistortionCoefficientsList = function() {
  return this.setDistortionCoefficientsList([]);
};


/**
 * optional DistortionModel.Enum distortion_model = 2;
 * @return {!proto.calibration.DistortionModel.Enum}
 */
proto.calibration.CameraIntrinsics.prototype.getDistortionModel = function() {
  return /** @type {!proto.calibration.DistortionModel.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.calibration.DistortionModel.Enum} value
 * @return {!proto.calibration.CameraIntrinsics} returns this
 */
proto.calibration.CameraIntrinsics.prototype.setDistortionModel = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional eigen_lcm.Vector2dPb focal_length = 3;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.calibration.CameraIntrinsics.prototype.getFocalLength = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 3));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.calibration.CameraIntrinsics} returns this
*/
proto.calibration.CameraIntrinsics.prototype.setFocalLength = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.calibration.CameraIntrinsics} returns this
 */
proto.calibration.CameraIntrinsics.prototype.clearFocalLength = function() {
  return this.setFocalLength(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.calibration.CameraIntrinsics.prototype.hasFocalLength = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional eigen_lcm.Vector2dPb principal_point = 4;
 * @return {?proto.eigen_lcm.Vector2dPb}
 */
proto.calibration.CameraIntrinsics.prototype.getPrincipalPoint = function() {
  return /** @type{?proto.eigen_lcm.Vector2dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector2d_pb.Vector2dPb, 4));
};


/**
 * @param {?proto.eigen_lcm.Vector2dPb|undefined} value
 * @return {!proto.calibration.CameraIntrinsics} returns this
*/
proto.calibration.CameraIntrinsics.prototype.setPrincipalPoint = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.calibration.CameraIntrinsics} returns this
 */
proto.calibration.CameraIntrinsics.prototype.clearPrincipalPoint = function() {
  return this.setPrincipalPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.calibration.CameraIntrinsics.prototype.hasPrincipalPoint = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.calibration);
